import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppAuthentication from "../Services/Authentication/AppAuthentication";
import alert_message from "../Services/Alert/AlertMessage";
import translator from "../Components/Extra/Translation/Translate";
import { getVendoAuthUrl } from "../Services/Authentication/Authentication";

export const useVendo = () => {
    const [loading, setLoading] = useState(false);
    const { singinVendoAsync } = AppAuthentication();
    const { translate } = translator();

    const [params] = useSearchParams();

    const token = params.get("token");

    const onConnect = async () => {
        setLoading(true);
        try {
            const url = await getVendoAuthUrl();
            setLoading(false);
            window.location.href = url;
        } catch (error: any) {
            setLoading(false);
            alert_message.error("Something went wrong");
            return;
        }
    };

    const connectionButton = ({ className }: { className?: string }) => {
        return (
            <button
                onClick={onConnect}
                type="button"
                className={`w-full text-black py-3 border-transparent hover:!bg-clisha-500 bg-white btn-hover1 inline-block overflow-hidden rounded-xl border-[1px] transition-all duration-300 ease-linear text-center  ${className}`}
            >
                {translate("Authentication", "Connect_to_vendo")}
            </button>
        );
    };

    useEffect(() => {
        if (token) {
            const promise = singinVendoAsync(token);
            alert_message.promise(
                `${translate("Authentication", "Sign_in")}`,
                promise,
            );
        }
    }, [token]);

    return { loading, connectionButton };
};
